var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCloseWhite = function SvgCloseWhite(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8334 1.3415L10.6584 0.166504L6.00002 4.82484L1.34169 0.166504L0.166687 1.3415L4.82502 5.99984L0.166687 10.6582L1.34169 11.8332L6.00002 7.17484L10.6584 11.8332L11.8334 10.6582L7.17502 5.99984L11.8334 1.3415Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCloseWhite);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExLjgzMzQgMS4zNDE1TDEwLjY1ODQgMC4xNjY1MDRMNi4wMDAwMiA0LjgyNDg0TDEuMzQxNjkgMC4xNjY1MDRMMC4xNjY2ODcgMS4zNDE1TDQuODI1MDIgNS45OTk4NEwwLjE2NjY4NyAxMC42NTgyTDEuMzQxNjkgMTEuODMzMkw2LjAwMDAyIDcuMTc0ODRMMTAuNjU4NCAxMS44MzMyTDExLjgzMzQgMTAuNjU4Mkw3LjE3NTAyIDUuOTk5ODRMMTEuODMzNCAxLjM0MTVaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";